module.exports = __webpack_public_path__ + "static/0016-c9c91eaa5d62bd3cfb52d69db6c3baa2.png";